import { render } from "./GameAdd.vue?vue&type=template&id=e6579384"
import script from "./GameAdd.vue?vue&type=script&lang=js"
export * from "./GameAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__